// src/pages/SignInLog.jsx
import { useState, useEffect } from 'react';
import { api } from '../api';
import { Card, SectionTitle, PageHeader, Table, TR, TD, Badge, Btn, Spinner, Empty } from '../components/UI';

export default function SignInLog() {
  const [rows, setRows]       = useState([]);
  const [date, setDate]       = useState(new Date().toISOString().slice(0, 10));
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    setLoading(true);
    const url = showAll ? '/api/signins/log?date=' : `/api/signins/log?date=${date}`;
    api.get(url).then(r => {
      if (r?.ok) setRows(r.data.rows || []);
      setLoading(false);
    });
  }, [date, showAll]);

  async function recordDeparture(id) {
    const r = await api.post(`/api/signin/${id}/departure`, {});
    if (r?.ok) {
      setRows(prev => prev.map(row => row.id === id ? { ...row, departure_time: r.data.departure_time } : row));
    }
  }

  return (
    <div style={{ padding: '20px 16px', maxWidth: 1100, margin: '0 auto' }}>
      <PageHeader
        title="Sign-In Log"
        subtitle={`${rows.length} record(s)`}
        actions={
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="date" value={date} onChange={e => { setDate(e.target.value); setShowAll(false); }} disabled={showAll}
              style={{ padding: '7px 10px', border: '1px solid var(--input-border)', background: 'var(--input-bg)', color: 'var(--fg)', fontSize: 13, opacity: showAll ? 0.4 : 1 }} />
            <button onClick={() => setShowAll(a => !a)} style={{
              padding: '7px 12px', border: '1px solid var(--border)', borderRadius: 'var(--radius)',
              background: showAll ? 'var(--accent)' : 'var(--bg3)', color: showAll ? '#fff' : 'var(--fg2)',
              cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font)',
            }}>All</button>
          </div>
        }
      />
      <Card>
        {loading ? <Spinner /> : rows.length === 0 ? <Empty message="No sign-ins for this date." /> : (
          <Table headers={['MBR #', 'Last Name', 'Type', 'Members', 'Guests', 'Payment', 'Total', 'Guard', 'Time', 'Departure', '']}>
            {rows.map(r => (
              <>
                <TR key={r.id} onClick={() => setExpanded(expanded === r.id ? null : r.id)}>
                  <TD>{r.membership_number}</TD>
                  <TD style={{ fontWeight: 'bold', color: 'var(--fg)' }}>{r.lastname}</TD>
                  <TD>{r.membership_type}</TD>
                  <TD>{r.member_people}</TD>
                  <TD>{r.guest_count > 0 ? r.guest_count : '—'}</TD>
                  <TD><Badge variant={r.payment_method === 'card' ? 'blue' : 'green'}>{r.payment_method}</Badge></TD>
                  <TD style={{ fontWeight: 'bold', color: 'var(--fg)' }}>${(r.total_charge || 0).toFixed(2)}</TD>
                  <TD>{r.guard_name}</TD>
                  <TD>{r.created_at ? r.created_at.slice(11, 16) : '—'}</TD>
                  <TD>{r.departure_time ? r.departure_time.slice(11, 16) : <span style={{ color: 'var(--fg4)' }}>—</span>}</TD>
                  <TD>
                    <span style={{ color: 'var(--accent)', fontSize: 11 }}>{expanded === r.id ? 'Close' : 'Details'}</span>
                  </TD>
                </TR>
                {expanded === r.id && (
                  <tr key={`${r.id}-detail`}>
                    <td colSpan={11} style={{ padding: '10px 16px', background: 'var(--bg2)', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
                        {r.caregiver_present ? <span style={{ fontSize: 12, color: 'var(--fg2)' }}>Caregiver present</span> : null}
                        {r.party_flag ? <Badge variant="amber">Party flag</Badge> : null}
                        {!r.departure_time && (
                          <Btn variant="outline" style={{ fontSize: 11 }} onClick={() => recordDeparture(r.id)}>Record Departure</Btn>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </Table>
        )}
      </Card>
    </div>
  );
}
